import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { TextInput } from '@delmonicos/shared-design-system-react/src/components/input/text-input';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { UpdateChargePointOcppConfigurationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/inputs/update-charge-point-ocpp-configuration.model';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';

import { useChargePointOcppConfigurationContext } from '../../charge-point.context';
import * as css from './charge-point-ocpp-configuration-update-form-step-1.module.scss';

export const ChargePointOcppConfigurationUpdateFormStep1Controller = ({
  isReadonly,
}: {
  isReadonly: boolean;
}): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  const { configurationKeys } = useChargePointOcppConfigurationContext();

  const { control } = useFormContext<
    UpdateChargePointOcppConfigurationModel & { chargePointId: string }
  >();

  // DYNAMIC FIELDS HANDLING /////////////////////////////////////////////////

  const { fields } = useFieldArray({
    control,
    name: 'configurations',
  });

  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <Stack
      className={css.chargePointFormStep1}
      direction="column"
      gap={GapEnum.L}>
      <Card>
        <Stack
          direction="column"
          justifyContent="stretch"
          alignItems="stretch"
          flex={1}
          gap={GapEnum.L}>
          {fields.map((configuration, index) => {
            return (
              <Controller
                key={configuration.key}
                name={`configurations.${index}`}
                control={control}
                disabled={isReadonly || configurationKeys?.[index]?.readonly}
                render={({ field, fieldState: { error } }) => {
                  return (
                    <Stack
                      direction="row"
                      gap={GapEnum.M}
                      alignItems="center"
                      justifyContent="stretch">
                      <TextInput
                        className={css.stretch}
                        label={field.value.key}
                        type="string"
                        errorMessage={error?.message}
                        {...field}
                        value={field.value.value ?? ''}
                        onChange={(e) =>
                          field.onChange(
                            e.target.value === ''
                              ? { key: field.value.key, value: '' }
                              : {
                                  key: field.value.key,
                                  value: e.target.value,
                                },
                          )
                        }
                      />
                    </Stack>
                  );
                }}
              />
            );
          })}
        </Stack>
      </Card>
    </Stack>
  );
};
